const routerEN = {
    "releases": {
        "view": {
            "name": "Releases",
            "buttonText": "Add New Release",
            "secondaryButtonText": "Transfer Release",
            "headerText": "Releases"
        },
        "add": {
            "name": "Add New Release",
            "headerText": "Releases"
        },
        "update": {
            "name": "Update Release",
            "headerText": "Releases"
        },
        "details": {
            "name": "Release Details",
            "headerText": "Releases"
        },
        "transfer": {
            "name": "Transfer Release",
            "headerText": "Releases"
        },
        "tracks": {
            "name": "Track List",
            "headerText": "Releases"
        },
        "deliveryConfirmation": {
            "name": "Delivered List",
            "headerText": "Delivered List"
        },
        "storeDeliveryList": {
            "name": "Store Delivery List",
            "headerText": "Store Delivery List"
        },
    },
    "copyrightInfringements": {
        "view": {
            "name": "Copyright Infringements",
            "headerText": "Copyright Infringements"
        },
    },
    "escrowWallet": {
        "view": {
            "name": "Escrow Wallet",
            "headerText": "Escrow Wallet"
        },
        "breakdown": {
            "name": "Escrow Payment Breakdown",
            "headerText": "Escrow Payment Breakdown"
        },
    },
    "artists": {
        "view": {
            "name": "Artists",
            "buttonText": "Add New Artist",
            "headerText": "Artists"
        },
        "add": {
            "name": "Add New Artist",
            "headerText": "Artists"
        },
        "update": {
            "name": "Update artist",
            "headerText": "Artists"
        },
        "viewDetails": {
            "name": "View Artist Details",
            "headerText": "View Artist Details"
        },
        "wishlist": {
            "name": "Artists Wishlist",
            "headerText": "Artists Wishlist"
        },
        "addFromWishlist": {
            "name": "Add Artist From Wishlist",
            "headerText": "Add Artist From Wishlist"
        },
    },
    "trends": {
        "view": {
            "name": "Trends",
            "headerText": "Trends"
        },
    },
    "earningsDrilldown": {
        "view": {
            "name": "Earnings",
            "headerText": "Earnings Drilldown"
        },
    },
    "accounting": {
        "view": {
            "name": "Smart Accounting",
            "headerText": "Smart Accounting",
            "buttonText": "Add New Accounting",
        },
        "add": {
            "name": "Add New Accounting",
            "headerText": "Add New Accounting",
        },
        "breakdown": {
            "name": "Accounting Breakdown",
            "headerText": "Accounting Breakdown"
        },
    },
    "invoices": {
        "view": {
            "name": "Invoices",
            "headerText": "Invoices",
            "buttonText": "Add Invoice",
        },
        "add": {
            "name": "Add Invoice",
            "headerText": "Add Invoice",
        },
    },
    "musicLink": {
        "view": {
            "name": "Music Link",
            "buttonText": "Add New Music Link",
            "headerText": "Music Link",
            "secondaryButtonText": "Music Link Url"
        },
        "add": {
            "name": "Add Music Link",
            "headerText": "Music Link",
        },
        "update": {
            "name": "Update Music Link",
            "headerText": "Music Link"
        },
        "viewStats": {
            "name": "Music Link View Stats",
            "headerText": "Music Link View Stats"
        },
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Music Link Urlpart",
            "buttonText": "Add New Music Link Urlpart",
            "headerText": "Music Link Urlpart",
        },
        "add": {
            "name": "Add New Music Link Urlpart",
            "headerText": "Music Link Urlpart",
        },
        "update": {
            "name": "Update Music Link Urlpart",
            "headerText": "Music Link Urlpart"
        },
    },
    "linkLandingPage": {
        "view": {
            "name": "Link Landing Page",
            "buttonText": "Add Link Landing Page",
            "headerText": "Link Landing Page",
        },
        "add": {
            "name": "Add Link Landing Page",
            "headerText": "Link Landing Page",
        },
        "update": {
            "name": "Update Link Landing Page",
            "headerText": "Link Landing Page"
        },
        "viewAnalytics": {
            "name": "Link Landing Page Analytics",
            "headerText": "Link Landing Page"
        },
    },
    "mastering": {
        "view": {
            "name": "Mastering",
            "buttonText": "Add Mastering",
            "headerText": "Audio Mastering",
        },
        "add": {
            "name": "Add Mastering",
            "headerText": "Audio Mastering",
        },
        "update": {
            "name": "Update Mastering",
            "headerText": "Audio Mastering",
        },
        "viewSongs": {
            "name": "Audio Mastering Songs",
            "headerText": "Audio Mastering Songs",
        },
    },
    "featureRequest": {
        "view": {
            "name": "Feature Request",
            "buttonText": "New Feature Request",
            "headerText": "Feature request",
        },
        "add": {
            "name": "Add Feature Request",
            "headerText": "Feature request",
        },
    },
    "scWhitelist": {
        "view": {
            "name": "SC Whitelist",
            "headerText": "SC Whitelist"
        },
    },
    "profile": {
        "view": {
            "name": "Profile",
            "headerText": "My Profile",
        },
    },
    "announcements": {
        "view": {
            "name": "Announcements",
            "headerText": "Announcements",
        },
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Two-Factor Authentication",
            "headerText": "Two-Factor Authentication",
        },
    },
    "completeYourInformation": {
        "view": {
            "name": "Complete Your Information",
            "headerText": "Complete Your Information",
        },
    },
    "tokens": {
        "view": {
            "name": "Tokens",
            "headerText": "Tokens",
        },
    },
    "orderTokens": {
        "view": {
            "name": "Order Tokens",
            "headerText": "Order Tokens",
        },
    },
    "accessKeys": {
        "view": {
            "name": "Access Keys",
            "headerText": "Access Keys",
        },
    },
    "paymentMethods": {
        "view": {
            "name": "Payment Methods",
            "buttonText": "Add Payment Method",
            "headerText": "My Payment Methods",
        },
        "add": {
            "name": "Add Payment Method",
            "headerText": "My Payment Methods",
        },
        "update": {
            "name": "Update Payment Method",
            "headerText": "My Payment Methods",
        },
    },
    "orderCredits": {
        "view": {
            "name": "Order Credits",
            "headerText": "Order Credits",
        },
    },
    "purchaseHistory": {
        "view": {
            "name": "Purchase History",
            "headerText": "Purchase History",
        },
    },
    "subscription": {
        "view": {
            "name": "My Subscription",
            "headerText": "My Subscription",
        },
        "upgrade": {
            "name": "Upgrade Subscription",
            "headerText": "Upgrade Subscription",
        },
    },
    "subUsers": {
        "view": {
            "name": "Sub Users",
            "buttonText": "Add New Sub-User",
            "headerText": "My Sub-Users",
        },
        "add": {
            "name": "Add New Sub-User",
            "headerText": "My Sub-Users",
        },
        "edit": {
            "name": "Edit Sub-User",
            "headerText": "My Sub-Users",
        },
    },
    "labels": {
        "view": {
            "name": "Labels",
            "buttonText": "Add New Label",
            "headerText": "My Labels",
        },
        "add": {
            "name": "Add New Label",
            "headerText": "My Labels",
        },
        "edit": {
            "name": "Edit Label",
            "headerText": "My Labels",
        },
    },
    "statements": {
        "view": {
            "name": "Statements",
            "headerText": "Financial Statements",
        },
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Subuser Statements",
            "headerText": "Subuser Statements",
        },
        "viewSubuser": {
            "name": "User Statements",
            "headerText": "User Statements",
        },
    },
    "dashboard": {
        "view": {
            "name": "Homepage",
            "headerText": "Homepage",
        },
    },
};

export default routerEN;
